import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function Portal(props) {
    const { mojitoTools, children } = props;
    const { config } = mojitoTools;
    const [targetEl, setTargetEl] = useState();

    useEffect(() => {
        const targetId = config.targetId;
        if (!targetId) {
            setTargetEl(undefined);
            return;
        }

        const el = document.getElementById(targetId);
        if (el) {
            setTargetEl(el);
            return;
        }

        setTargetEl(undefined);

        const observeElementId = config.observeElementId;
        const observeRoot = observeElementId
            ? (document.getElementById(observeElementId) ?? document.body)
            : document.body;

        const observer = new MutationObserver(() => {
            const foundEl = document.getElementById(targetId);
            if (foundEl) {
                setTargetEl(foundEl);
                observer.disconnect();
            }
        });

        observer.observe(observeRoot, { childList: true, subtree: true });

        return () => {
            observer.disconnect();
        };
    }, [config.targetId, config.observeElementId]);

    if (!targetEl) {
        return null;
    }
    return createPortal(children, targetEl);
}
